import React from 'react';

// Importing icons to match the card style
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Context', value: 'Demand-to-Cash', delta: 'connected', tone: 'blue', icon: <QuestionAnswerIcon />, deltaTone: 'blue' },
    { label: 'Answers', value: 'Explainable', delta: 'driver based', tone: 'green', icon: <CheckCircleIcon />, deltaTone: 'good' },
    { label: 'Actions', value: 'Governed', delta: 'human-in-loop', tone: 'purple', icon: <ListAltIcon />, deltaTone: 'good' },
    { label: 'Impact', value: 'Measured', delta: '₹ outcome', tone: 'orange', icon: <AttachMoneyIcon />, deltaTone: 'good' },
];

const RECOMMENDED_ACTIONS = [
    { action: 'Increase North run', owner: 'Planning', impact: '₹8 Cr' },
    { action: 'Redeploy 65k', owner: 'Supply', impact: '₹9 Cr' },
    { action: 'Protect Premium mix', owner: 'S&OP', impact: '₹6 Cr' },
    { action: 'Monitor fill', owner: 'Sales', impact: 'Service' },
];

export class AskEPM extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userQuery: 'Why is Maharashtra Premium A demand above plan, and what should we change?'
        };
    }

    handleInputChange = (e) => {
        this.setState({ userQuery: e.target.value });
    }

    render() {
        const { userQuery } = this.state;

        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>AskEPM — AI Performance Assistant</h1>
                        <p>Ask why performance changed, simulate alternatives and initiate governed cross-functional action.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the card style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row askepm-main-row">
                    {/* Left Panel: Conversation */}
                    <div className="cc-panel askepm-conversation-panel">
                        <h2>AskEPM Conversation</h2>
                        
                        {/* Text Area Input */}
                        <textarea
                            className="askepm-textarea"
                            value={userQuery}
                            onChange={this.handleInputChange}
                            placeholder="Ask a question about your supply chain performance..."
                        />

                        {/* AI Response Block */}
                        <div className="askepm-response-box">
                            <p>Latest demand is 14.5% above the operating plan. Primary sales run-rate and lower days of cover indicate a near-term availability risk.</p>
                            <p className="askepm-recommendation">
                                <strong>Recommended:</strong> increase North L1 production by 40k cases and redeploy 65k cases from West Bengal. Estimated revenue protected: ₹18 Cr.
                            </p>
                        </div>

                        {/* Action Buttons */}
                        <div className="askepm-button-row">
                            <button className="askepm-action-btn">Show demand drivers</button>
                            <button className="askepm-action-btn">Run scenario</button>
                            <button className="askepm-action-btn">Create actions</button>
                        </div>
                    </div>

                    {/* Right Panel: Recommended Actions */}
                    <div className="cc-panel cc-panel-table askepm-actions-panel">
                        <h2>Recommended Actions</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Action</th>
                                    <th>Owner</th>
                                    <th>Impact</th>
                                </tr>
                            </thead>
                            <tbody>
                                {RECOMMENDED_ACTIONS.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.action}</td>
                                        <td>{row.owner}</td>
                                        <td>{row.impact}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default AskEPM;